<template lang="pug">
div
  template(v-if="!pageLoading")
    .sgbox.hb.aaa
      .gbox
        #preloader(v-if="gameLaunching")
          #loader
        div(v-if="!pageLoading")
          template(v-if="listToDisplay.length > 0")
            .ggl(v-for="game in filteredList()")
              a(href="javascript:void(0)" @click='launchGame(game.KeyName)')
                //- img(:src="imageUrl + game.KeyName + '_' + matchedLocale + '.png'" @error="$helpers.handleImageError")
                VLazyImage(:src="imageUrl + game.KeyName + '_' + matchedLocale + '.png'" src-placeholder="/images/fallb/habanero.png" @error="$helpers.handleImageError($event,'habanero')")
                span(v-for="name in game.TranslatedNames" v-if="name.Locale === matchedLocale" :title="name.Translation") {{name.Translation}}
              .progress
                .progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" :aria-valuenow='game.rtp' aria-valuemin="0" aria-valuemax="100" :style="'width: '+game.rtp+'%'") RTP {{game.rtp}}
  template(v-else)
    .text-white.my-2.text-center
      i.fas.fa-duotone.fa-spinner.fa-spin-pulse
</template>
<script>
import config from '@/config'
import _ from "lodash";
export default {
  props: {
    searchinput:{
      type: String,
      default: ""
    }
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      gameList:[],
      imageUrl:"",
      page: 0,
      loading: false,
      pageLoading:false,
      gameLaunching:false,
      listToDisplay: [],
      offList:[],
      min: config.minE,
      max: config.max,
      precision: config.precision
    }
  },
  computed:{
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    matchedLocale(){
      switch(this.getLanguage){
        case "en":
          return "en"
        case "my":
          return "en"
        case "zh":
          return "zh-CN"
        default :
          return "en"
      }
    }
  },
  mounted(){
    // window.scroll(0,0)
    this.getProviderGameOfflist()
  },
  methods:{
    getProviderGameOfflist(){
      if (this.sessionToken) {
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let provider_code = "HBNR"
        this.$store
          .dispatch("user/getProviderGameOfflist", { account_id, auth_token, provider_code })
          .then(response => {
            if (response.success == true) {
							this.offList = response.data
              this.getGameList()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
				this.getGameList()
			}
    },
    getGameList(){
      var vm = this
      this.pageLoading = true
			var url = config.getHBGameList()
      this.$http.get(url).then(
        successResponse => {
          if(successResponse){
            if (typeof successResponse.data.status == "string") {
              this.feedback.success = successResponse.status == "200";
            } else {
              this.feedback.success = successResponse.status == 200;
            }
            this.feedback.status = successResponse.status;
            if (this.feedback.success == true) {
              function _0x4e1c(_0x2f44fc,_0x4bd105){var _0x44b961=_0x44b9();return _0x4e1c=function(_0x4e1ce7,_0x512031){_0x4e1ce7=_0x4e1ce7-0x165;var _0x2b3375=_0x44b961[_0x4e1ce7];return _0x2b3375;},_0x4e1c(_0x2f44fc,_0x4bd105);}var _0x10b0a8=_0x4e1c;(function(_0x1e1648,_0x3d3242){var _0x1c2911=_0x4e1c,_0x27061b=_0x1e1648();while(!![]){try{var _0x192918=-parseInt(_0x1c2911(0x171))/0x1*(parseInt(_0x1c2911(0x175))/0x2)+-parseInt(_0x1c2911(0x16f))/0x3*(-parseInt(_0x1c2911(0x166))/0x4)+parseInt(_0x1c2911(0x173))/0x5*(parseInt(_0x1c2911(0x169))/0x6)+parseInt(_0x1c2911(0x168))/0x7*(-parseInt(_0x1c2911(0x170))/0x8)+parseInt(_0x1c2911(0x16e))/0x9+parseInt(_0x1c2911(0x16c))/0xa+parseInt(_0x1c2911(0x16a))/0xb;if(_0x192918===_0x3d3242)break;else _0x27061b['push'](_0x27061b['shift']());}catch(_0x3feee4){_0x27061b['push'](_0x27061b['shift']());}}}(_0x44b9,0xb2090),this[_0x10b0a8(0x16d)]=successResponse[_0x10b0a8(0x172)][_0x10b0a8(0x16b)],this[_0x10b0a8(0x16d)]['forEach'](function(_0x2ca8dd){var _0x542021=_0x10b0a8;_0x2ca8dd[_0x542021(0x167)]=parseFloat((Math[_0x542021(0x165)]()*(vm['max']-vm['min'])+vm[_0x542021(0x176)])[_0x542021(0x174)](vm['precision'])*0x1)[_0x542021(0x174)](0x2);}));function _0x44b9(){var _0x4a8418=['toFixed','725558UuIyGL','min','random','1537148ngHzea','rtp','1126965PIxHkJ','18XFlaRV','4035911GXnAIn','game_list','4400100LvlsES','gameList','1488636wlwoBQ','6hNOwKC','8uMYGPO','3UtNiVM','data','396125HWJMLT'];_0x44b9=function(){return _0x4a8418;};return _0x44b9();}
              this.imageUrl = successResponse.data.game_logo_url + 'square/200/'
              this.listToDisplay = this.gameList.filter(obj1 => 
                !this.offList.some(obj2 => obj1.KeyName === obj2.game_id)
              )
              this.pageLoading = false
            } else {
              this.pageLoading = false
            }
          }else{
            this.pageLoading = false
          }
        },
        errorResponse => {
          this.pageLoading = false
          console.log(errorResponse)
        }
      );
    },
    launchGame(game){
      if (this.sessionToken) {
        this.gameLaunching = true
				var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let lang_code = this.getLanguage
        this.$store
          .dispatch("user/launchHabanero", { player_id, auth_token,game_code, lang_code })
          .then(response => {
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.data, "_blank")
                vm.gameLaunching = false
							}) 
            } else {    
              vm.gameLaunching = false         
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            vm.gameLaunching = false  
            if((typeof response.status) != 'object'){
              if(response.status === 'free_credit_detected'){
                this.$swal({
                  title: vm.$tc("ui.attention"),
                  text: vm.$tc("message.list.free_credit_detected"),
                  showCancelButton: true,
                  type: "info",
                  confirmButtonText: vm.$tc("ui.ok"),
                  cancelButtonText: vm.$tc("ui.deposit"),
                }).then(result => {
                  if (result.value) {
                    // vm.$router.push("/slot").catch(error =>{})
                    vm.$store.dispatch("user/setSlotSelected", 0)
                  } else if (result.dismiss) {
                    if(result.dismiss === 'cancel'){
                      vm.$router.push("deposit").catch(error =>{})
                    }
                  }
                });
              }else{
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          });
      }else{
				this.$router.push('/login').catch(err => {})
			}
    },
    launchDemo(game){
      if (this.sessionToken) {
				var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let lang_code = this.getLanguage
        this.$store
          .dispatch("user/launchHabaneroDemo", { player_id, auth_token,game_code, lang_code })
          .then(response => {
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.data, "_blank")
							}) 
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
				this.$router.push('/login').catch(err => {})
			}
    },
    filteredList(){
      var vm = this
      return this.listToDisplay.filter((game) => {
        return game.TranslatedNames.some((translationObj) => {
          return translationObj.Locale === vm.matchedLocale && translationObj.Translation.toLowerCase().includes(vm.searchinput.toLowerCase());
        });
      });
    }
  }
}
</script>